import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { ARDocFormat, IsrDocFormat } from '@usf/payment-types';
import { PAYMENTS_ANALYTICS_ACTIONS } from './payments-analytics.actions';
import { PaymentsAnalyticsMessages } from './payments-analytics.constants';
import {
  defaultTransformer,
  paymentsPageLoad,
  viewInvoicePageLoad,
} from './payments-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class PaymentsAnalyticsService {
  constructor(private store: Store) {}

  trackPageLoad(): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          pageName: PaymentsAnalyticsMessages.pageName,
          event: PaymentsAnalyticsMessages.pageLoadedEvent,
          capability: PaymentsAnalyticsMessages.capability,
        },
        transformFunc: paymentsPageLoad,
      },
    };
    this.store.dispatch(PAYMENTS_ANALYTICS_ACTIONS.trackPageLoad({ tracking }));
  }

  trackDownload(
    fileCount: number,
    docFormat: IsrDocFormat | ARDocFormat,
    fileTypeBase: string = PaymentsAnalyticsMessages.fileTypeBase,
  ): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          event: PaymentsAnalyticsMessages.sharePrintDownloadEvent,
          capability: PaymentsAnalyticsMessages.capability,
          file: {
            fileCount: fileCount,
            type: this.getFileType(docFormat, fileTypeBase),
          },
        },
        transformFunc: defaultTransformer,
      },
    };
    this.store.dispatch(
      PAYMENTS_ANALYTICS_ACTIONS.trackInvoicesDownload({ tracking }),
    );
  }

  trackView(pageName = PaymentsAnalyticsMessages.viewInvoicePageName) {
    const tracking: Tracking = {
      analytics: {
        data: {
          pageName,
          event: PaymentsAnalyticsMessages.pageLoadedEvent,
          capability: PaymentsAnalyticsMessages.capability,
        },
        transformFunc: viewInvoicePageLoad,
      },
    };
    this.store.dispatch(
      PAYMENTS_ANALYTICS_ACTIONS.trackViewInvoicePageLoad({ tracking }),
    );
  }

  getFileType(
    docFormat: IsrDocFormat | ARDocFormat,
    fileTypeBase: string,
  ): string {
    let fileType = fileTypeBase;
    switch (docFormat) {
      case IsrDocFormat.CSV_FULL:
      case IsrDocFormat.CSV_LINES:
      case ARDocFormat.CSV:
        return fileType + 'csv';
      case IsrDocFormat.EXCELFLAT:
      case IsrDocFormat.EXCELTAB:
        return fileType + 'xls';
      case IsrDocFormat.PDF:
      case ARDocFormat.PDF:
        return fileType + 'pdf';
      case IsrDocFormat.QB_BILL:
        return fileType + 'quickbooks';
      case IsrDocFormat.XML:
        return fileType + 'xml';
    }
    return '';
  }
}
